export const API = process.env.REACT_APP_API_URL;
export const URL = process.env.REACT_APP_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const HESABE_MERCHANT_CODE = process.env.REACT_APP_HESABE_MERCHANT_CODE;
export const HESABE_ACCESS_CODE = process.env.REACT_APP_HESABE_ACCESS_CODE;
export const HESABE_SECRET_KEY = process.env.REACT_APP_HESABE_SECRET_KEY;
export const HESABE_IV_KEY = process.env.REACT_APP_HESABE_IV_KEY;
